// extracted by mini-css-extract-plugin
export default {"error":"price_error__Kdg6K"};